export const getUTCDate = (s: string) => {
  return new Date(s).toISOString();
};

export const getStringDate = (s: string) => {
  const date = new Date(s);
  if (date.toString() === "Invalid Date") {
    return "";
  }
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};
